
<template>
     <router-link to="/user/complete-profile" v-if="!isProfileComplete()" class="complete-profile-btn">
                        <i class="fas fa-user-edit"></i> <span class="d-none d-lg-inline">Complete Profile</span>
                    </router-link>
</template>
<script setup>
import { isProfileComplete } from '@/utils/auth';

</script>
<style scoped>
.complete-profile-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white !important;
  padding: 8px 16px;
  border-radius: 24px;
  font-weight: 600;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
  margin: 0 12px;
}

.complete-profile-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

</style>